export default {
    survey: {
        start_message: {
            id: 'survey.start_message',
            defaultMessage: 'Start survey message...',
        },
        start_button: {
            id: 'survey.start_button',
            defaultMessage: 'Start',
        },
        unavailable: {
            id: 'survey.unavailable',
            defaultMessage: 'Unavailable',
        },
        invalid: {
            id: 'survey.invalid',
            defaultMessage: 'Invalid',
        },
    },
    instance: {
        next_button: {
            id: 'instance.next_button',
            defaultMessage: 'Next',
        },
        loading: {
            id: 'instance.loading',
            defaultMessage: 'Loading...',
        },
    },
    error: {
        validation: {
            REQUIRED_ERROR: {
                id: 'error.validation.required_error',
                defaultMessage: 'Required field',
            },
            NOT_NUMBER_ERROR: {
                id: 'error.validation.not_number_error',
                defaultMessage: 'Invalid number',
            },
            MIN_NUMBER_ERROR: {
                id: 'error.validation.min_number_error',
                defaultMessage: 'Invalid number',
            },
            MAX_NUMBER_ERROR: {
                id: 'error.validation.max_number_error',
                defaultMessage: 'Invalid number',
            },
            STEP_NUMBER_ERROR: {
                id: 'error.validation.step_number_error',
                defaultMessage: 'Invalid step',
            },
            STRING_ERROR: {
                id: 'error.validation.string_error',
                defaultMessage: 'Invalid field',
            },
            NOT_DATE_ERROR: {
                id: 'error.validation.not_date_error',
                defaultMessage: 'Invalid date',
            },
            MIN_DATE_ERROR: {
                id: 'error.validation.min_date_error',
                defaultMessage: 'Invalid date',
            },
            MAX_DATE_ERROR: {
                id: 'error.validation.max_date_error',
                defaultMessage: 'Invalid date',
            },
            INVALID_CHOICE_ERROR: {
                id: 'error.validation.invalid_choice_error',
                defaultMessage: 'Invalid choice',
            },
            MIN_CHOICES_ERROR: {
                id: 'error.validation.min_choices_error',
                defaultMessage: 'Invalid number of choices (min {min})',
            },
            MAX_CHOICES_ERROR: {
                id: 'error.validation.max_choices_error',
                defaultMessage: 'Invalid number of choices (max {max})',
            },
            MIN_CHOICES_ROW_ERROR: {
                id: 'error.validation.min_choices_row_error',
                defaultMessage: 'Invalid number of choices (min {min})',
            },
            MAX_CHOICES_ROW_ERROR: {
                id: 'error.validation.max_choices_row_error',
                defaultMessage: 'Invalid number of choices (max {max})',
            },
            UPLOAD_SIZE_ERROR: {
                id: 'error.validation.upload_size_error',
                defaultMessage: 'Selected file too big (max {max})',
            },
            UPLOAD_TYPE_IMAGE_ERROR: {
                id: 'error.validation.upload_type_image_error',
                defaultMessage: 'Selected file is not an image',
            },
            OCCURRENCIES_ERROR: {
                id: 'error.validation.occurrencies_error',
                defaultMessage: 'Invalid number of choices',
            },
            MIN_OCCURRENCIES_ERROR: {
                id: 'error.validation.min_occurrencies_error',
                defaultMessage: 'Invalid number of choices',
            },
            MAX_OCCURRENCIES_ERROR: {
                id: 'error.validation.max_occurrencies_error',
                defaultMessage: 'Invalid number of choices',
            },
            COMPOSITION_ERROR: {
                id: 'error.validation.composition_error',
                defaultMessage: 'Invalid number',
            },
            MIN_CHOICES_ORDER_ERROR: {
                id: 'error.validation.min_choices_order_error',
                defaultMessage: 'Invalid number of ordered elements (min {min})',
            },
            OVERALL_REQUIRED_ERROR: {
                id: 'error.validation.overall_required_error',
                defaultMessage: 'All fields are mandatory; fields marked in red have an error',
            },
            OVERALL_MAX_NUMBER_ERROR: {
                id: 'error.validation.overall_max_number_error',
                defaultMessage: 'The values of individual fields cannot be greater than {max}; fields marked in red have an error',
            },
            OVERALL_MIN_NUMBER_ERROR: {
                id: 'error.validation.overall_min_number_error',
                defaultMessage: 'The values of individual fields cannot be less than {min}; fields marked in red have an error',
            },
            OVERALL_COMPOSITION_ERROR: {
                id: 'error.validation.overall_composition_error',
                defaultMessage: 'The sum of the field values must be equal to {max}; recheck the values assigned to the fields',
            },
        },
    },
    label: {
        day: {
            id: 'label.day',
            defaultMessage: 'Giorno',
        },
        month: {
            id: 'label.month',
            defaultMessage: 'Mese',
        },
        year: {
            id: 'label.year',
            defaultMessage: 'Anno',
        },
        chooseImage: {
            id: 'label.chooseImage',
            defaultMessage: 'Choose image',
        },
        chooseImageMax: {
            id: 'label.chooseImageMax',
            defaultMessage: '(max {max})',
        },
        removeImage: {
            id: 'label.removeImage',
            defaultMessage: 'remove image',
        },
        total: {
            id: 'label.total',
            defaultMessage: 'total',
        },
        required_ordered_elements_reached: {
            id: 'label.required_ordered_elements_reached',
            defaultMessage: 'Required ordered elements reached. You can go to the next page!',
        },
    },
    placeholder: {
        day: {
            id: 'placeholder.day',
            defaultMessage: 'DD',
        },
        month: {
            id: 'placeholder.month',
            defaultMessage: 'MM',
        },
        year: {
            id: 'placeholder.year',
            defaultMessage: 'YY',
        },
    },
};
